import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { accountApi, type Device, type PasswordChange } from '@/entities/user';

export const accountKeys = {
    devices: ['account', 'devices'] as const,
};

/** De eigen apparaten, dit apparaat eerst en ingetrokken apparaten achteraan. */
export function useDevices() {
    return useQuery({
        queryKey: accountKeys.devices,
        queryFn: async (): Promise<Device[]> =>
            [...(await accountApi.devices())].sort(
                (a, b) =>
                    Number(b.current) - Number(a.current) ||
                    Number(a.revoked) - Number(b.revoked) ||
                    (b.lastSeenAt ?? '').localeCompare(a.lastSeenAt ?? ''),
            ),
    });
}

export function useRenameDevice() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (input: { uuid: string; name: string }) =>
            accountApi.renameDevice(input.uuid, input.name),
        onSuccess: () => client.invalidateQueries({ queryKey: accountKeys.devices }),
    });
}

export function useRevokeDevice() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (uuid: string) => accountApi.revokeDevice(uuid),
        onSuccess: () => client.invalidateQueries({ queryKey: accountKeys.devices }),
    });
}

/** Een ingetrokken apparaat mag weer inloggen; de lijst toont het daarna weer als apparaat met toegang. */
export function useRestoreDevice() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (uuid: string) => accountApi.restoreDevice(uuid),
        onSuccess: () => client.invalidateQueries({ queryKey: accountKeys.devices }),
    });
}

/** Andere apparaten zijn daarna uitgelogd; de lijst verandert dus ook. */
export function useChangePassword() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (input: PasswordChange) => accountApi.changePassword(input),
        onSuccess: () => client.invalidateQueries({ queryKey: accountKeys.devices }),
    });
}
